module.exports = __webpack_public_path__ + "static/media/YM69_0.29689679.jpg";